import {fetchBaseQuery} from '@reduxjs/toolkit/query';

export const baseUrl = process.env.REACT_APP_API_URL;

const ingnoreEndpoints = [
	'obtenerProyectoPorCodigo',
	'login',
	'recuperarContrasena',
	'obtenerUnidadesAcademicas',
	'cambiarContrasena',
	'usuariosDisponibles',
];

const baseQuery = fetchBaseQuery({
	baseUrl,
	prepareHeaders: (headers, api) => {
		const token: string | undefined = localStorage.getItem('token') ?? undefined;
		if (!ingnoreEndpoints.includes(api.endpoint)) {
			if (token) {
				headers.set('authorization', `Bearer ${token}`);
			}
		}

		return headers;
	},

});

export default baseQuery;
